import React, { useEffect, useState, useContext } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import PageKit from "../../data/PageKit";
import LayoutPrivate from "../../components/LayoutPrivate";
import Navigation from "../../components/Navigation/Navigation";
import { UserContext } from "../../contexts/UserContext";
import { GlobalPageDataContext } from "../../contexts/GlobalPageDataContext";
import PageHead from "../../components/PageHead";
import { ChatContext } from "../../contexts/ChatContext";

import EventBrowserInitView from "../../components/Views/EventBrowserInitView";
import EventMobileInitView from "../../components/Views/EventMobileInitView";
import { isMobileOrTablet } from "../../components/Views/MobileClassRenderer";
import CustomCSSRenderer from "../../components/CustomCSSRenderer";
import FirebaseAuthGuard from "../../components/FirebaseAuthGuard";
import useViewStatistics from "../../components/hooks/useViewStatistics";

export default function EventIndexPage({ event }) {
  useViewStatistics();

  const [mainPage, setMainPage] = useState(null);
  const pageKit = new PageKit();
  const router = useRouter();
  const { me } = useContext(UserContext);
  const { hasUnreadMessages } = useContext(ChatContext);
  const { globalPageData, setGlobalPageData } = useContext(
    GlobalPageDataContext
  );

  function fetchMainPage() {
    const pageSlug = `${event}`;
    const globalPageItem = globalPageData[pageSlug];
    if (globalPageItem) {
      setMainPage(globalPageItem);
    } else {
      pageKit
        .getMainPage(event)
        .then((res) => {
          setMainPage(res);
          setGlobalPageData((prevState) => ({
            ...prevState,
            [pageSlug]: res,
          }));
        })
        .catch((errors) => {
          router.push("/[event]/register", `/${event}/register`);
        });
    }
  }
  useEffect(() => {
    window && window.scrollY > 0 && window.scrollTo(0);
  }, []);

  useEffect(() => {
    fetchMainPage();
  }, []);

  return (
    <FirebaseAuthGuard>
      <LayoutPrivate>
        {mainPage && (
          <PageHead
            eventTitle={mainPage.event.title}
            hasUnreadMessages={hasUnreadMessages}
          // pageCustomCss={mainPage.customCss}
          />
        )}

        <CustomCSSRenderer pageCSS={mainPage?.customCss} />

        {mainPage && (
          <>
            {isMobileOrTablet() ? (
              <EventMobileInitView mainPage={mainPage} event={event} />
            ) : (
              <EventBrowserInitView mainPage={mainPage} event={event} />
            )}
          </>
        )}
      </LayoutPrivate>
    </FirebaseAuthGuard>
  );
}

EventIndexPage.getInitialProps = ({ query }) => {
  return {
    event: query.event,
  };
};
